<template>
    
    <div :class="audit_mode !== true && previous !== true ? '': 'gray-600 font-scale-sm'">
        <div :class="previous == true ? 'p-3 gray-500 rounded border border-color-gray-300 bgray-100' : 'pb-5'">
            <template v-if="!isFieldEmpty(sub_description) && sub_description.includes('Media Stakeholder Analysis') !== true">
                <b-overlay :show="is_visible_by_pipeline === false"
                    rounded="sm"
                    opacity="0.8"
                    bg-color="#efefef"
                    >
                    <div v-if="headers">
                        <div :class="[{'fw-500 f-110 mb-2': sub_name !== ''}]">
                            <span v-if="sub_data_header.required && sub_data_header.required==true">*</span>
                            {{ showTranslation(sub_name, sub_name_e, sub_name_c) }}
                        </div>
                        <div :class="[ isFieldEmpty(sub_description) ? 'mb-2': '', 'mb-1']">
                            <div v-if="is_indicate_description" class="mr-1 d-inline px-0">
                                <span v-if="(isFieldEmpty(sub_description) || !sub_description.includes('Media Stakeholder Analysis')) && audit_mode !== true">
                                    {{ showTranslation(sub_description, sub_description_e, sub_description_c) }}
                                </span>
                            </div>
                            <span v-for="item in tags" :key="item.id">
                                <span v-if="item !== ''" class="ml-2 f-80 gray-500"> {{ item }} </span>
                            </span>
                            <span v-if="!isFieldEmpty(sub_info) && (isFieldEmpty(sub_description) || !sub_description.includes('Media Stakeholder Analysis'))" class="ml-2">
                                <b-button
                                    :id="`i-${ sub_code }`"
                                    class="p-0"
                                    variant="icon"
                                    size="lg"
                                    :title="button_title"
                                    @click="toggleVisible"
                                    v-b-tooltip.hover
                                    >
                                    <fa icon="info-circle"></fa>
                                </b-button>
                            </span>
                            <span v-if="sub_priority !== ''">
                                <b-badge :variant="badge_var" class="mx-2">{{ sub_priority }}</b-badge>
                            </span>
                            <b-button v-if="typeof previous_sub.sub_code !== 'undefined' && previous !== true"
                                v-b-toggle="previous_sub.sub_code"
                                size="sm"
                                variant="icon"
                                class="ml-2"
                                v-b-tooltip.hover
                                :title="$t('지난해 답변 확인하기')"
                                >
                                <fa icon="history"></fa>
                            </b-button>

                            <!-- sub_info 정보 -->
                            <template v-if="!isFieldEmpty(sub_info) && (isFieldEmpty(sub_description) || !sub_description.includes('Media Stakeholder Analysis'))">
                                <b-collapse
                                    :id="`sub_info-${sub_code}`"
                                    :visible="print_mode !== true && audit_mode !== true"
                                    class="rounded mb-3 border-0 teal8 bg-teal2 f-95"
                                    >
                                    <div v-html="showTranslation(sub_info, sub_info_e, sub_info_c)" class="p-3"></div>
                                </b-collapse>
                            </template>

                            <!-- sub_condition -->
                            <div v-if="is_sub_condition_activated === true"
                                :id="`sub_condition-${sub_code}`"
                                class="my-2 py-2"
                                >
                                <b-form-checkbox
                                    v-model="sub_condition.value"
                                    @change="radioSave"
                                    :disabled="is_locked || is_disabled_by_parent"
                                    >
                                    {{ sub_condition.text }}
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>

                    <!-- textbox 유형 Sub Component -->
                    <b-form-textarea :id="form_id"
                        v-model.trim="sub_data_contents.result[0]"
                        :rows="textarea_rows" 
                        @update="textInputSave"
                        @blur="textInputSave(false, true)"
                        :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || is_disabled_by_na"
                        :placeholder="showTranslation(sub_data_contents.placeholder, sub_data_contents.placeholder_ea, sub_data_contents.placeholder_ca)"
                        >
                    </b-form-textarea>

                    <!-- file 저장 --> 
                    <template v-if="sub_data_header.has_attachment">
                        <df-attached-file-url
                            :key="is_loaded + Math.random()"
                            class="mt-3"
                            :sub_id="sub_id"
                            :sub_code="sub_code"
                            :sub_init_id="sub_init_id"
                            :company_id="company_id"
                            :company_name="company_name"
                            :campaign_id="campaign_id"
                            :disabled="is_disabled_attached"
                            :audit_mode="audit_mode"
                            :has_attachment="sub_data_header.has_attachment"
                            :previous="previous"
                            :label="label"
                            >
                        </df-attached-file-url>
                    </template>


                    <!-- 저장 validation -->
                    <div v-if="previous !== true && audit_mode !== true"
                        :class="validation_style" @click="retrySave"
                        class="mt-2"
                        >
                        <fa v-if="validation_icon !== ''" :icon="validation_icon"></fa> {{ validation_comment }}
                    </div>
                    
                    <!-- Child Component -->
                    <sub-component v-for="(item, index) in child_subs" :key="item.id"
                        :is_final_sub_component="index == child_subs.length -1 ? true : false"
                        :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent" 
                        :sub_type="item.sub_type" 
                        :item="item" 
                        :audit_mode="audit_mode" 
                        :is_disabled_by_parent="is_disabled_by_parent"
                        >
                    </sub-component>
                    
                    <!-- is_visible_by_pipeline 조건에 따른 해당없음 overlay -->
                    <template v-slot:overlay>
                        <DFPipelineOverlay :prev_sub_info="prev_sub_info"
                                           :pipeline_title="pipeline_title"
                        />
                    </template>
                </b-overlay>
            </template>
        </div>

        <!-- previous component -->
        <b-collapse v-if="print_mode !== true" :id="previous_sub.sub_code">
            <sub-component
                v-if="typeof previous_sub.sub_code !== 'undefined' && previous != true"
                :item="previous_sub"
                :sub_type="previous_sub.sub_type"
                :is_disabled_by_parent="true"
                :previous="true"
                :disabled="true"
                >
            </sub-component>
        </b-collapse>
    </div>
</template>

<script>
import { SubComponentMixin } from '@core_mixins/SubComponentMixin'
import DFPipelineOverlay from "@core_components/client/components/subs/elements/DFPipelineOverlay";

export default {
    name: 'df-textbox',
    mixins: [SubComponentMixin],
    components: {
        DFPipelineOverlay,
    },
    data () {
        return {}
    },
    computed: {
        textarea_rows () {
            if (this.sub_data_header.rows && this.sub_data_header.rows !== 0 ) { 
                return this.sub_data_header.rows
            } else { 
                return 8 
            }
        }
    },
    methods:{}
}
</script>

<style>

</style>
